export default __webpack_public_path__ + "static/media/chip2.8e219c0b.png";